export const PhoneFrame = ({ children, className = "", testId }) => (
  <div
    data-testid={testId}
    className={`relative w-[270px] h-[560px] rounded-[2.6rem] border-[6px] border-[#1c2030] bg-[#0b0d14] shadow-2xl overflow-hidden shrink-0 ${className}`}
  >
    <div className="absolute top-2.5 left-1/2 -translate-x-1/2 w-24 h-5 bg-[#1c2030] rounded-full z-20" />
    <div className="absolute inset-0 pt-10 flex flex-col">{children}</div>
  </div>
);

export default PhoneFrame;
